var _path, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGtt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "9 9 287 105.5",
    height: 37,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4ED869",
    d: "M100.48,33.57l-38.36,0c-15.92,0-24.76,11.1-24.76,28.3c0,17.69,9.33,29.43,26.85,29.43c8.84,0,17.53-3.7,21.55-11.74H63.41V59.94h48.16v52.58l-21.66,0v-11.26c-5.63,9.33-18.46,13.19-31.49,13.19c-27.98,0-49.21-21.23-49.21-52.58c0-31.2,23-52.58,52.26-52.58h50.15L100.48,33.57z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#4ED869",
    points: "192.77,33.57 203.93,9.29 120.02,9.29 108.87,33.57 142.81,33.57 142.81,112.52 169.99,112.52 169.99,33.57"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#4ED869",
    points: "285.11,33.57 296.09,9.29 212.36,9.29 201.2,33.57 235.15,33.57 235.15,112.52 262.32,112.52 262.32,33.57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtt);
export default __webpack_public_path__ + "static/media/gtt.638907813744775552ef4c6ff37dbd3c.svg";
export { ForwardRef as ReactComponent };